<template>
	<div>
		<q-table
			:data="users_invited"
			:columns="columns_users_invited"
			:pagination.sync="server_pagination"
			selection="multiple"
			:selected.sync="users_invited_selected"
			@request="requestGuests"
			:loading="loading"
			:filter="filter_guests"
			row-key="user_id"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			class="q-mt-md"
			binary-state-sort
			v-if="
				presential_seats.length === 0 &&
					!presential_event_using_presential_catalog &&
					!loading_seats
			"
		>
			<template slot="top" slot-scope="props" :props="props">
				<q-input
					:float-label="$t('guests_quantity')"
					dense
					v-model="qtyGuestsInvited"
					disable
					readonly
				/>
				<div class="col" />

				<q-search
					v-model="filter_guests"
					:debounce="600"
					icon="far fa-search"
					class="q-mr-md"
					:placeholder="$t('search')"
				/>

				<q-btn
					color="tertiary"
					v-show="permissions.subscribe_event_users && users_invited.length > 0"
					class="q-mr-md"
					icon="far fa-file-download"
					:label="$t('download_guest_list')"
					@click="downloadGuestList"
					:disable="users_invited.length < 1"
				/>

				<q-btn
					color="negative"
					v-show="permissions.subscribe_event_users && users_invited_selected.length > 0"
					icon="far fa-ban"
					:label="$t('remove')"
					@click="confirmRemoveGuests"
					class="q-mr-sm"
					:disable="disableGuests"
				/>

				<q-btn
					class="q-mr-md"
					v-show="canImportGuests"
					color="secondary"
					icon="far fa-plus"
					:label="$t('import_guests')"
					@click="showImportGuests"
					:disable="disableGuests || users_invited.length >= max_participants"
				>
					<q-tooltip v-if="!first_event_date">
						{{ $t('there_are_no_events_for_this_training_yet') }}
					</q-tooltip>
					<q-tooltip
						v-if="
							permissions.subscribe_event_users &&
								subscription_restrictions &&
								!is_admin &&
								disableGuests
						"
					>
						{{ $t('subscription_time_limit_reached') }}
					</q-tooltip>
					<q-tooltip v-if="!permissions.subscribe_event_users && disableGuests">
						{{ $t('you_are_not_allowed_to_subscribe_users') }}
					</q-tooltip>
				</q-btn>

				<q-btn
					color="secondary"
					icon="far fa-plus"
					:label="$t('subscribe_users')"
					@click="showAddGuests"
					:disable="disableGuests"
				>
					<q-tooltip v-if="!first_event_date">
						{{ $t('there_are_no_events_for_this_training_yet') }}
					</q-tooltip>
					<q-tooltip
						v-if="
							permissions.subscribe_event_users &&
								subscription_restrictions &&
								!is_admin &&
								disableGuests
						"
					>
						{{ $t('subscription_time_limit_reached') }}
					</q-tooltip>
					<q-tooltip v-if="!permissions.subscribe_event_users && disableGuests">
						{{ $t('you_are_not_allowed_to_subscribe_users') }}
					</q-tooltip>
				</q-btn>

				<div
					class="col-12 q-pt-sm"
					v-if="subscription_restrictions && !is_admin && day_before_first_event !== ''"
				>
					<p class="text-weight-light">
						{{ `${$t('subscription_period_until')}: ${fDate(day_before_first_event)}` }}
					</p>
				</div>
			</template>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th auto-width>
					<q-checkbox
						v-model="props.selected"
						indeterminate-value="some"
						:disable="disableGuests"
						@input="selectAllGuests()"
					/>
				</q-th>

				<q-th
					v-for="col in props.cols"
					:key="col.name"
					:props="props"
					v-show="col.name === 'status' ? showColumnGuestStatus : true"
				>
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<q-tr slot="body" slot-scope="props">
				<q-td auto-width>
					<q-checkbox
						color="primary"
						v-model="props.selected"
						:disable="disableGuests || props.row.invited_and_deleted"
					/>
				</q-td>

				<q-td key="user_id" :props="props">
					{{ props.row.user_id }}
				</q-td>

				<q-td key="full_name" :props="props">
					{{ props.row.full_name }}
				</q-td>

				<q-td key="email" :props="props">
					{{ props.row.email }}
				</q-td>

				<q-td key="phone" :props="props">
					{{ props.row.phone }}
				</q-td>

				<q-td key="document" :props="props">
					{{ props.row.document }}
				</q-td>

				<q-td key="branches" :props="props">
					<q-btn
						v-if="props.row.branches.length > 1"
						color="primary"
						text-color="white"
						:label="getQuantityBranches(props.row.branches)"
						no-ripple
					>
						<q-tooltip>
							<p v-if="props.row.branches.length > 1" class="tooltip q-mb-sm">
								{{ $t('branches') }}:
								<span v-for="(branch, index) in props.row.branches" :key="index">
									{{ branch }}
									<span v-if="props.row.branches.length - 1 > index">, </span>
								</span>
							</p>
						</q-tooltip>
					</q-btn>
					<span v-if="props.row.branches.length < 2">{{
						String(props.row.branches)
					}}</span>
				</q-td>

				<q-td key="areas" :props="props">
					<q-btn
						v-if="props.row.areas.length > 1"
						color="primary"
						text-color="white"
						:label="props.row.areas ? props.row.areas.length : 0"
						no-ripple
					>
						<q-tooltip>
							<p v-if="props.row.areas.length > 1" class="tooltip q-mb-sm">
								{{ $t('areas') }}:
								<span v-for="(area, index) in props.row.areas" :key="index">
									{{ getArea(area) }}
									<span v-if="props.row.areas.length - 1 > index">, </span>
								</span>
							</p>
						</q-tooltip>
					</q-btn>
					<span v-if="props.row.areas.length === 1">
						{{ getArea(props.row.areas[0]) }}
					</span>
				</q-td>

				<q-td key="profile" :props="props">
					{{ translateProfiles(props.row.profile) }}
				</q-td>

				<q-td
					key="invited_and_deleted"
					:props="props"
					v-show="showColumnGuestStatus"
					:class="props.row.invited_and_deleted ? 'text-negative' : ''"
				>
					<q-icon
						name="fal fa-plus"
						v-if="props.row.invited_and_deleted && props.row.invited_and_deleted_logs"
					>
						<q-tooltip>
							<span
								v-for="(invited_and_deleted_log, index) in props.row
									.invited_and_deleted_logs"
								:key="index"
							>
								{{ $t('removed_by') }}:
								{{ invited_and_deleted_log.author_full_name }} {{ $t('in') }}
								{{ fDate(invited_and_deleted_log.created_date) }}<br />
								{{ $t('observation') }}: {{ invited_and_deleted_log.observation
								}}<br />
							</span>
						</q-tooltip>
					</q-icon>
					{{ props.row.invited_and_deleted ? $t('not_invited') : $t('invited') }}
				</q-td>

				<q-td auto-width key="actions" :props="props">
					<q-btn
						round
						flat
						icon="fal fa-trash"
						color="negative"
						@click="confirmRemoveGuest(props)"
						:disable="disableRemoveGuests || props.row.invited_and_deleted"
					>
						<q-tooltip>
							{{ $t('delete_tooltip') }}
						</q-tooltip>
					</q-btn>
				</q-td>
			</q-tr>
		</q-table>

		<div
			class="row gutter-sm q-mb-md"
			v-if="presential_seats.length > 0 && presential_event_contain_dates && !loading_seats"
		>
			<div class="col-12">
				<q-input
					:float-label="$t('users_registered_for_the_event')"
					:value="
						`${qty_presential_event_filled_seats}/${qty_presential_event_available_seats}`
					"
					disable
				/>
			</div>

			<div
				class="col-12"
				v-if="qty_presential_event_filled_seats >= qty_presential_event_available_seats"
			>
				<q-alert color="negative" icon="fal fa-exclamation" class="full-width">
					{{ $t('there_are_no_more_vacancies_for_this_event') }}
				</q-alert>
			</div>
		</div>

		<div
			class="row gutter-sm"
			v-if="presential_seats.length > 0 && presential_event_contain_dates && !loading_seats"
		>
			<div class="col-12">
				<q-select
					filter
					v-model="seat_tab"
					:options="
						presential_seats.map((e) => {
							return {
								value: e.tab,
								label: `${e.branch_document} - ${e.branch_name}`,
								...e,
							}
						})
					"
					:float-label="$t('branch')"
					@input="loadGuests(seat_tab)"
				/>
			</div>

			<div
				class="col-12"
				v-if="!seat_tab_qty_available_seats_to_this_event && !loading_seat_tab_users"
			>
				<q-alert color="negative" icon="fal fa-exclamation" class="full-width">
					{{
						$t('vacancies_already_filled_for_this_dealership_consult_planned_vacancies')
					}}
				</q-alert>
			</div>

			<!--
				===== Planned vacancies =====
			-->
			<div class="col-12">
				<q-table
					:data="
						seat_tab_users.filter(
							(e) =>
								e.is_invited_to_this_event ||
								e.invited_and_deleted ||
								getPlannedVacanciesGuestStatus(e) === 'enrollment_canceled'
						)
					"
					:columns="columns_users_invited"
					row-key="user_id"
					:no-data-label="$t('no_data_avaliable')"
					:no-results-label="$t('no_results_found')"
					:rows-per-page-label="$t('items_per_page')"
					:loading-label="$t('loading_data')"
					:rows-per-page-options="[5, 10, 50, 100]"
					class="q-mt-md"
					binary-state-sort
					:loading="loading_seat_tab_users"
				>
					<!-- :pagination.sync="server_pagination" -->
					<template slot="top" slot-scope="props" :props="props">
						<q-input
							:float-label="$t('guests_quantity')"
							dense
							:value="
								`${seat_tab_qty_presential_event_filled_seats}/${seat_tab_qty_available_seats_to_this_event}`
							"
							disable
							readonly
						/>

						<div class="col" />

						<q-btn
							color="secondary"
							icon="far fa-plus"
							:label="$t('subscribe_users')"
							@click="showAddUserSeats(seat_tab)"
							:disable="
								seat_tab_qty_available_seats_to_this_event <=
									seat_tab_qty_presential_event_filled_seats ||
									disableAddUserSeats(seat_tab)
							"
						>
							<q-tooltip
								v-if="
									permissions.subscribe_event_users &&
										subscription_restrictions &&
										!is_admin &&
										disableGuests
								"
							>
								{{ $t('subscription_time_limit_reached') }}
							</q-tooltip>
							<q-tooltip v-if="!permissions.subscribe_event_users && disableGuests">
								{{ $t('you_are_not_allowed_to_subscribe_users') }}
							</q-tooltip>
						</q-btn>

						<div
							class="col-12 q-pt-sm"
							v-if="
								subscription_restrictions &&
									!is_admin &&
									day_before_first_event !== ''
							"
						>
							<p class="text-weight-light">
								{{
									`${$t('subscription_period_until')}: ${fDate(
										day_before_first_event
									)}`
								}}
							</p>
						</div>
					</template>

					<q-tr slot="header" slot-scope="props" :props="props">
						<q-th
							v-for="col in props.cols"
							:key="col.name"
							:props="props"
							v-show="col.name === 'status' ? showColumnGuestStatus : true"
						>
							{{ $t(col.label) }}
						</q-th>
					</q-tr>

					<q-tr slot="body" slot-scope="props">
						<q-td key="user_id" :props="props">
							{{ props.row.user_id }}
						</q-td>

						<q-td key="full_name" :props="props">
							{{ props.row.full_name }}
						</q-td>

						<q-td key="email" :props="props">
							{{ props.row.email }}
						</q-td>

						<q-td key="phone" :props="props">
							{{ props.row.phone }}
						</q-td>

						<q-td key="document" :props="props">
							{{ props.row.document }}
						</q-td>

						<q-td key="branches" :props="props">
							<q-btn
								v-if="props.row.branches.length > 1"
								color="primary"
								text-color="white"
								:label="getQuantityBranches(props.row.branches)"
								no-ripple
							>
								<q-tooltip>
									<p v-if="props.row.branches.length > 1" class="tooltip q-mb-sm">
										{{ $t('branches') }}:
										<span
											v-for="(branch, index) in props.row.branches"
											:key="index"
										>
											{{ branch }}
											<span v-if="props.row.branches.length - 1 > index"
												>,
											</span>
										</span>
									</p>
								</q-tooltip>
							</q-btn>
							<span v-if="props.row.branches.length < 2">{{
								String(props.row.branches)
							}}</span>
						</q-td>

						<q-td key="areas" :props="props">
							<q-btn
								v-if="props.row.areas.length > 1"
								color="primary"
								text-color="white"
								:label="props.row.areas ? props.row.areas.length : 0"
								no-ripple
							>
								<q-tooltip>
									<p v-if="props.row.areas.length > 1" class="tooltip q-mb-sm">
										{{ $t('areas') }}:
										<span v-for="(area, index) in props.row.areas" :key="index">
											{{ getArea(area) }}
											<span v-if="props.row.areas.length - 1 > index"
												>,
											</span>
										</span>
									</p>
								</q-tooltip>
							</q-btn>
							<span v-if="props.row.areas.length === 1">
								{{ getArea(props.row.areas[0]) }}
							</span>
						</q-td>

						<q-td key="profile" :props="props">
							{{ translateProfiles(props.row.profile) }}
						</q-td>

						<q-td
							key="invited_and_deleted"
							:props="props"
							v-show="showColumnGuestStatus"
							:class="
								props.row.invited_and_deleted
									? 'text-negative'
									: getPlannedVacanciesGuestStatus(props.row) ===
									  'enrollment_canceled'
									? 'text-negative'
									: ''
							"
						>
							<q-icon
								name="fal fa-exclamation-triangle"
								class="q-pr-sm"
								v-if="
									props.row.invited_and_deleted &&
										props.row.invited_and_deleted_logs
								"
							>
								<q-tooltip>
									<span
										v-for="(invited_and_deleted_log, index) in props.row
											.invited_and_deleted_logs"
										:key="index"
									>
										{{ $t('removed_by') }}:
										{{ invited_and_deleted_log.author_full_name }}
										{{ $t('in') }}
										{{ fDate(invited_and_deleted_log.created_date) }}<br />
										{{ $t('observation') }}:
										{{ invited_and_deleted_log.observation }}<br />
									</span>
								</q-tooltip>
							</q-icon>

							<q-icon
								name="fal fa-exclamation-triangle"
								class="q-pr-sm"
								v-if="
									getPlannedVacanciesGuestStatus(props.row) ===
										'enrollment_canceled'
								"
							>
								<q-tooltip>
									<span
										v-for="(invited_and_deleted_log, index) in props.row
											.invited_and_deleted_logs"
										:key="index"
									>
										{{ $t('removed_by') }}:
										{{ invited_and_deleted_log.author_full_name }}
										{{ $t('in') }}
										{{ fDate(invited_and_deleted_log.created_date) }}<br />
										{{ $t('observation') }}:
										{{ invited_and_deleted_log.observation }}<br />
									</span>
								</q-tooltip>
							</q-icon>
							{{ $t(getPlannedVacanciesGuestStatus(props.row)) }}
						</q-td>

						<q-td auto-width key="actions" :props="props">
							<q-btn
								round
								flat
								icon="fal fa-trash"
								color="negative"
								@click="confirmRemoveUserInSeats(props, seat_tab)"
								:disable="disableRemoveGuests || props.row.invited_and_deleted"
							>
								<q-tooltip>
									{{ $t('remove') }}
								</q-tooltip>
							</q-btn>

							<q-btn
								round
								flat
								icon="fal fa-user-times"
								color="secondary"
								:disable="
									disableCancelSubscription ||
										getPlannedVacanciesGuestStatus(props.row) === 'deleted'
								"
								@click="cancelUserSubscription(props.row, seat_tab)"
							>
								<q-tooltip v-if="props.row.invited_and_deleted">
									{{ $t('user_removed') }}
								</q-tooltip>
								<q-tooltip v-else>
									{{ $t('enrollment_cancellation_request') }}
								</q-tooltip>
							</q-btn>
						</q-td>
					</q-tr>
				</q-table>
			</div>
		</div>

		<q-alert
			v-if="
				!loading_seats &&
					!presential_event_contain_dates &&
					presential_event_using_presential_catalog
			"
			color="warning"
			icon="fal fa-exclamation-triangle"
		>
			{{ $t('it_is_necessary_to_inform_event_dates_before_enrolling_students') }}
		</q-alert>

		<q-modal
			v-model="show_add_user_seats"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="show_add_user_seats = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title>
						{{ $t('guests') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-table
						:data="users_not_in_seats"
						:columns="users_not_in_seat_columns"
						:pagination.sync="users_not_in_seat_pagination"
						selection="multiple"
						:selected.sync="users_not_in_seats_selected"
						row-key="user_id"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
						binary-state-sort
						hide-bottom
					>
						<template slot="top" slot-scope="props" :props="props">
							<div class="col" />

							<q-btn
								color="positive"
								icon="far fa-plus"
								:label="$t('subscribe_users')"
								@click="addUserNotInSeats()"
								v-if="users_not_in_seats_selected.length > 0"
								:disable="checkAddUserNotInSeats()"
							>
								<q-tooltip v-if="checkAddUserNotInSeats()">
									{{
										$t(
											'the_number_of_users_selected_is_greater_than_the_number_of_places_available'
										)
									}}
								</q-tooltip>
							</q-btn>
						</template>

						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th auto-width>
								<q-checkbox
									v-model="props.selected"
									indeterminate-value="some"
									@input="selectAllNotInSeats()"
								/>
							</q-th>

							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>

						<q-tr slot="body" slot-scope="props" :props="props">
							<q-td auto-width>
								<q-checkbox
									color="primary"
									v-model="props.selected"
									:disable="
										props.row.allowed_to_be_invited_to_this_event ? false : true
									"
								>
									<q-tooltip
										v-if="!props.row.allowed_to_be_invited_to_this_event"
									>
										{{
											$t('user_already_certified_or_invited_to_another_event')
										}}
									</q-tooltip>
								</q-checkbox>
							</q-td>

							<q-td key="user_id" :props="props">
								{{ props.row.user_id }}
							</q-td>

							<q-td key="full_name" :props="props">
								{{ props.row.full_name }}
							</q-td>

							<q-td key="email" :props="props">
								{{ props.row.email }}
							</q-td>

							<q-td key="branches" :props="props">
								<q-btn
									v-if="props.row.branches.length > 1"
									color="primary"
									text-color="white"
									:label="getQuantityBranches(props.row.branches)"
									no-ripple
								>
									<q-tooltip v-if="props.row.branches.length > 1">
										<p class="tooltip q-mb-sm">
											{{ $t('branches') }}:
											<span
												v-for="(branch, index) in props.row.branches"
												:key="index"
											>
												{{ branch }}
												<span v-if="props.row.branches.length - 1 > index"
													>,
												</span>
											</span>
										</p>
									</q-tooltip>
								</q-btn>
								<span v-if="props.row.branches.length < 2">{{
									String(props.row.branches)
								}}</span>
							</q-td>

							<q-td key="profile" :props="props">
								{{ translateProfiles(props.row.profile) }}
							</q-td>
						</q-tr>
					</q-table>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal
			v-model="show_guests"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="closeGuestModal" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('guests') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-table
						:data="guests_list"
						:columns="guests_columns"
						:pagination.sync="new_guests_pagination"
						:filter="filter_guests"
						@request="requestNewGuests"
						:loading="loading"
						selection="multiple"
						:selected.sync="users_invited_selected"
						row-key="id"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
						binary-state-sort
					>
						<template slot="top" slot-scope="props" :props="props">
							<q-search
								v-model="filter_guests"
								icon="far fa-search"
								class="q-mr-lg"
								:placeholder="$t('search')"
								:float-label="$t('search')"
								:debounce="600"
							/>

							<q-select
								chips
								multiple
								v-model="area"
								:options="getAllowedAreas"
								:float-label="$t('area')"
								class="q-mr-md"
								@input="changeAddFilter()"
							/>

							<q-select
								chips
								multiple
								v-model="profile"
								:options="getAllowedProfiles"
								:float-label="$t('profiles')"
								@input="changeAddFilter()"
								class="q-mr-md"
							/>

							<q-input
								v-if="current_client === 'academiacoral'"
								ref="branches"
								v-model="branches"
								:float-label="$t('branches')"
								:value-field="(v) => `${v.label}`"
								class="q-mr-md"
								:debounce="600"
								clearable
								@clear="clearAutoComplete"
							>
								<q-autocomplete
									@search="fetchBranches"
									@selected="selectedBranch"
									:min-characters="3"
									separator
								/>
							</q-input>

							<q-input
								v-if="current_client === 'academiacoral'"
								ref="company"
								v-model="companies"
								:float-label="$t('company')"
								:debounce="600"
								clearable
								@clear="clearAutoComplete"
							>
								<q-autocomplete
									@search="fetchCompanies"
									@selected="selectedCompany"
									:min-characters="3"
									separator
								/>
							</q-input>

							<div class="col" />
							<q-btn
								color="positive"
								icon="far fa-plus"
								:label="$t('subscribe_users')"
								@click="addGuests()"
								v-if="users_invited_selected.length > 0"
							/>
						</template>

						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th auto-width>
								<q-checkbox v-model="props.selected" indeterminate-value="some" />
							</q-th>

							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>

						<q-tr slot="body" slot-scope="props" :props="props">
							<q-td auto-width>
								<q-checkbox color="primary" v-model="props.selected" />
							</q-td>

							<q-td key="id" :props="props">
								{{ props.row.id }}
							</q-td>

							<q-td key="full_name" :props="props">
								{{ props.row.full_name }}
							</q-td>

							<q-td key="email" :props="props">
								{{ props.row.email }}
							</q-td>

							<q-td key="branches" :props="props">
								<q-btn
									v-if="props.row.branches.length > 1"
									color="primary"
									text-color="white"
									:label="getQuantityBranches(props.row.branches)"
									no-ripple
								>
									<q-tooltip v-if="props.row.branches.length > 1">
										<p class="tooltip q-mb-sm">
											{{ $t('branches') }}:
											<span
												v-for="(branch, index) in props.row.branches"
												:key="index"
											>
												{{ branch }}
												<span v-if="props.row.branches.length - 1 > index"
													>,
												</span>
											</span>
										</p>
									</q-tooltip>
								</q-btn>
								<span v-if="props.row.branches.length < 2">{{
									String(props.row.branches)
								}}</span>
							</q-td>

							<q-td key="companies" :props="props">
								<q-btn
									v-if="props.row.companies.length > 1"
									color="primary"
									text-color="white"
									:label="getQuantityCompanies(props.row.companies)"
									no-ripple
								>
									<q-tooltip v-if="props.row.companies.length > 1">
										<p class="tooltip q-mb-sm">
											{{ $t('company') }}:
											<span
												v-for="(company, index) in props.row.companies"
												:key="index"
											>
												{{ company }}
												<span v-if="props.row.companies.length - 1 > index"
													>,
												</span>
											</span>
										</p>
									</q-tooltip>
								</q-btn>
								<span v-if="props.row.branches.length < 2">{{
									String(props.row.branches)
								}}</span>
							</q-td>

							<q-td key="profile" :props="props">
								{{ translateProfiles(props.row.profile) }}
							</q-td>
						</q-tr>
					</q-table>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal
			v-model="show_guests_import"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="show_guests_import = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title>
						{{ $t('import_guests') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<p class="q-mb-none text-weight-light q-mb-md">
						{{ $t('guests_import_template_start') }}
						<span class="text-weight-medium cursor-pointer" @click="getTemplate"
							>presential_event_users.xlsx</span
						>
						{{ $t('guests_import_template_end') }}
					</p>
					<uploader
						content_type="xlsx"
						@fileUploaded="userImportUpload"
						:multiple="false"
						:cropper="false"
						:guest_import="true"
					/>

					<div class="row gutter-sm justify-end q-mt-lg">
						<div class="col-xs-12 col-sm-3">
							<q-btn
								color="negative"
								class="full-width"
								:label="$t('cancel')"
								icon="far fa-times"
								@click="show_guests_import = false"
							/>
						</div>

						<div class="col-xs-12 col-sm-3">
							<q-btn
								color="secondary"
								class="full-width"
								:label="$t('save')"
								icon="far fa-save"
								@click="importUser()"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal
			v-model="show_create_users"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="hideCreateUsers()" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('new_users') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-sm">
						<div class="col-xs-12 col-sm-3">
							<q-field
								:error="new_user.email_error"
								:error-label="
									new_user.email_error ? `${$t('email_not_unique')}` : ''
								"
							>
								<q-input
									:float-label="$t('email')"
									v-model="new_user.email"
									:error="$v.new_user.email.$error"
									@input="$v.new_user.email.$touch"
									@blur="emailUnique()"
									:disable="!this.register_fields.email_fields"
								/>
							</q-field>
						</div>

						<div class="col-xs-12 col-sm-3">
							<q-field
								:error="new_user.document_error"
								:error-label="
									new_user.document_error ? $t('document_not_unique') : ''
								"
							>
								<q-input
									:float-label="$t('document')"
									v-model="new_user.document"
									:error="$v.new_user.document.$error"
									@input="$v.new_user.document.$touch"
									@blur="documentUnique()"
								/>
							</q-field>
						</div>

						<div class="col-xs-12 col-sm-2">
							<q-select
								:float-label="$t('profile')"
								v-model="new_user.profile"
								:options="register_profiles"
								:error="$v.new_user.profile.$error"
								@input="$v.new_user.profile.$touch"
							/>
						</div>

						<div class="col-xs-12 col-sm-3">
							<q-input
								:float-label="$t('full_name')"
								v-model="new_user.full_name"
								:error="$v.new_user.full_name.$error"
								@input="$v.new_user.full_name.$touch"
							/>
						</div>

						<div class="col-xs-12 col-sm-1">
							<q-btn
								class="q-mt-md"
								round
								flat
								color="positive"
								icon="fal fa-plus"
								@click="addNewUser()"
							/>
						</div>
					</div>

					<div class="row gutter-sm" v-for="(user, index) in new_users" :key="index">
						<div class="col-xs-12 col-sm-3">
							<q-input :float-label="$t('email')" v-model="user.email" disable />
						</div>

						<div class="col-xs-12 col-sm-3">
							<q-input
								:float-label="$t('document')"
								v-model="user.document"
								disable
							/>
						</div>

						<div class="col-xs-12 col-sm-2">
							<q-select
								:float-label="$t('profile')"
								:options="register_profiles"
								v-model="user.profile"
								disable
							/>
						</div>

						<div class="col-xs-12 col-sm-3">
							<q-input
								:float-label="$t('full_name')"
								v-model="user.full_name"
								disable
							/>
						</div>

						<div class="col-xs-12 col-sm-1">
							<q-btn
								class="q-mt-md"
								color="negative"
								round
								flat
								icon="fal fa-trash"
								@click="removeNewUser(index)"
							/>
						</div>
					</div>

					<div class="row gutter-sm justify-end q-mt-lg">
						<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
							<q-btn
								color="tertiary"
								class="full-width"
								:label="$t('cancel')"
								icon="far fa-chevron-left"
								@click="hideCreateUsers()"
							/>
						</div>

						<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
							<q-btn
								color="secondary"
								class="full-width"
								:label="$t('save_new_users')"
								icon="far fa-save"
								@click="saveNewUsers()"
								:disable="new_users.length === 0 ? true : false"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-dialog v-model="confirm_remove_guest">
			<span slot="title">{{ $t('remove_guest') }}</span>

			<span slot="message">{{ $t('do_you_want_to_remove_this_guest') }}</span>

			<div slot="body">
				<q-input
					type="textarea"
					:placeholder="$t('observation')"
					v-model="confirm_remove_guests_observation"
				/>
			</div>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn
					color="tertiary"
					:label="$t('close')"
					@click="confirm_remove_guest = false"
				/>
				<q-btn color="negative" :label="$t('remove')" @click="removeGuest()" />
			</template>
		</q-dialog>

		<q-dialog v-model="confirm_remove_guests">
			<span slot="title">{{ $t('remove_guests') }}</span>

			<span slot="message">{{ $t('do_you_want_to_remove_the_selected_guests') }}</span>

			<div slot="body">
				<q-input
					type="textarea"
					:placeholder="$t('observation')"
					v-model="confirm_remove_guests_observation"
				/>
			</div>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn
					color="tertiary"
					:label="$t('close')"
					@click="confirm_remove_guests = false"
				/>
				<q-btn color="negative" :label="$t('remove')" @click="removeGuests()" />
			</template>
		</q-dialog>

		<q-dialog v-model="confirm_remove_user_in_seats">
			<span slot="title">{{ $t('remove_guest') }}</span>

			<span slot="message">{{ $t('do_you_want_to_remove_this_guest') }}</span>

			<div slot="body">
				<q-input
					type="textarea"
					:placeholder="$t('observation')"
					v-model="confirm_remove_guests_observation"
				/>
			</div>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn
					color="tertiary"
					:label="$t('close')"
					@click="confirm_remove_user_in_seats = false"
				/>
				<q-btn color="negative" :label="$t('remove')" @click="removeUserInSeats()" />
			</template>
		</q-dialog>

		<cancel-subscription
			:show_subscription_history="show_subscription_history"
			:presential_event_id="presential_event_id"
			:user="user_to_cancel_subscription"
			:allow_enrollment_cancellation="allow_enrollment_cancellation"
			@save_cancellation_and_load_guests="saveCancellationAndLoadGuests"
			@hide_subscription_history="hideSubscriptionHistory()"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, email } from 'vuelidate/lib/validators'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import Uploader from 'components/Uploader'
import CancelSubscription from 'components/admin/presential/CancelSubscription'

export default {
	name: 'AdminPresentialGuests',

	props: ['status', 'permissions', 'allowed_areas', 'allowed_profiles', 'current_client'],

	components: {
		uploader: Uploader,
		'cancel-subscription': CancelSubscription,
	},

	data() {
		return {
			max_participants: 0,
			presential_event_id: '',
			users_invited: [],
			users_invited_selected: [],
			show_guests: false,
			show_guests_import: false,
			filter_guests: '',
			guests_list: [],
			company: [],
			companies: [],
			branches: [],
			profile: [],
			area: [],
			columns_users_invited: [
				{
					name: 'user_id',
					required: true,
					label: '#',
					align: 'left',
					field: 'user_id',
					sortable: true,
				},
				{
					name: 'full_name',
					sort: 'user__full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: true,
				},
				{
					name: 'email',
					sort: 'user__email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: true,
				},
				{
					name: 'phone',
					required: true,
					label: 'celular',
					align: 'left',
					field: 'phone',
					sortable: false,
				},
				{
					name: 'document',
					sort: 'user__user_data__document',
					required: true,
					label: 'document',
					align: 'left',
					field: 'document',
					sortable: true,
				},
				{
					name: 'branches',
					required: true,
					label: 'branches',
					align: 'left',
					field: 'branches',
					sortable: false,
				},
				{
					name: 'areas',
					required: true,
					label: 'areas',
					align: 'left',
					field: 'areas',
					sortable: false,
				},
				{
					name: 'profile',
					required: true,
					label: 'profile',
					align: 'left',
					field: 'profile',
					sortable: false,
				},
				{
					name: 'invited_and_deleted',
					required: true,
					label: 'status',
					align: 'left',
					field: 'invited_and_deleted',
					sortable: false,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'right',
					field: 'actions',
					sortable: false,
				},
			],
			guests_columns: [
				{
					name: 'id',
					sort: 'user_id',
					required: true,
					label: '#',
					align: 'left',
					field: 'id',
					sortable: true,
				},
				{
					name: 'full_name',
					sort: 'full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: true,
				},
				{
					name: 'email',
					sort: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: true,
				},
				{
					name: 'branches',
					required: false,
					label: 'branches',
					align: 'left',
					field: 'branches',
					sortable: false,
				},
				{
					name: 'companies',
					required: false,
					label: 'company',
					align: 'left',
					field: 'companies',
					sortable: false,
				},
				{
					name: 'profile',
					required: true,
					label: 'profile',
					align: 'left',
					field: 'profile',
					sortable: false,
				},
			],
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 5,
				descending: false,
				sortBy: null,
			},
			new_guests_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 5,
				descending: false,
				sortBy: null,
			},
			loading: false,
			show_create_users: false,
			new_user: {
				email: '',
				email_error: false,
				document: '',
				document_error: false,
				profile: '',
				full_name: '',
			},
			new_users: [],
			file: '',
			file_url: '',
			presential_seats: [],
			seat_tab: 't0',
			loading_seats: false,
			users_not_in_seats: [],
			show_add_user_seats: false,
			users_not_in_seats_selected: [],
			users_not_in_seat_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 0,
				descending: false,
				sortBy: null,
			},
			users_not_in_seat_columns: [
				{
					name: 'user_id',
					required: true,
					label: '#',
					align: 'left',
					field: 'user_id',
					sortable: false,
				},
				{
					name: 'full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: false,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: false,
				},
				{
					name: 'branches',
					required: false,
					label: 'branches',
					align: 'left',
					field: 'branches',
					sortable: false,
				},
				{
					name: 'profile',
					required: true,
					label: 'profile',
					align: 'left',
					field: 'profile',
					sortable: false,
				},
			],
			qty_presential_event_filled_seats: 0,
			qty_presential_event_available_seats: 0,
			selected_seat_tab: {},
			presential_event_contain_dates: false,
			presential_event_using_presential_catalog: false,
			confirm_remove_guests: false,
			confirm_remove_guests_observation: '',
			confirm_remove_guests_user: {},
			confirm_remove_guest: false,
			confirm_remove_user_in_seats_user: {},
			confirm_remove_user_in_seats: false,
			occupied_vacancies: 0,
			seat_tab_users: [],
			loading_seat_tab_users: false,
			seat_tab_qty_presential_event_filled_seats: 0,
			seat_tab_qty_available_seats_to_this_event: 0,
			first_event_date: '',
			day_before_first_event: '',
			is_admin: false,
			subscription_restrictions: false,
			show_subscription_history: false,
			user_to_cancel_subscription: null,
			allow_enrollment_cancellation: false,
			filter_pagination: {
				page: 0,
			},
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			areas: 'registration_lists/country_areas',
			areas_client: 'registration_lists/areas_client',
			clients: 'params/clients',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			num_rows: 'datatable/num_rows',
			profiles: 'registration_lists/profiles',
			register_fields: 'params/register_fields',
			register_profiles: 'registration_lists/profiles',
			register_store: 'params/register',
			user_branches: 'common/user_branches',
			user_clients: 'common/user_clients',
			user_companies: 'common/user_companies',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '90vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		disableGuests() {
			if (!this.first_event_date) return true

			if (
				!this.permissions.subscribe_event_users ||
				this.occupied_vacancies >= this.max_participants
			) {
				return true
			} else {
				if (!this.subscription_restrictions) {
					if (
						this.status === 1 ||
						this.status === 2 ||
						this.status === 3 ||
						this.status === 4 ||
						this.presential_event_id == 0
					)
						return false
					else return true
				} else {
					if (this.status === 1 || this.status === 2 || this.presential_event_id == 0) {
						if (this.is_admin) {
							return false
						} else {
							let dateNow = new Date()
							let diff = date.getDateDiff(
								dateNow,
								this.day_before_first_event,
								'minutes'
							)
							if (diff >= 0) return true
							else return false
						}
					} else return true
				}
			}
		},

		canImportGuests() {
			if (
				process.env.PROJECT_FOLDER === 'universidadechevrolet' &&
				this.permissions.subscribe_event_users
			) {
				return this.is_admin
			} else return this.permissions.subscribe_event_users
		},

		disableRemoveGuests() {
			if (this.permissions.subscribe_event_users) {
				if (this.subscription_restrictions) {
					if (this.status === 1 || this.status === 2) return false
					else return true
				} else {
					if (
						this.status === 1 ||
						this.status === 2 ||
						this.status === 3 ||
						this.status === 4 ||
						this.presential_event_id == 0
					) {
						return false
					} else return true
				}
			} else return true
		},

		disableCancelSubscription() {
			if (this.permissions.subscribe_event_users) {
				if (
					this.status === 3 ||
					this.status === 4 ||
					this.status === 5 ||
					this.status === 8
				)
					return false
				else return true
			} else return true
		},

		qtyGuestsInvited() {
			return `${this.occupied_vacancies}/${this.max_participants}`
		},

		getAllowedAreas() {
			let allowed_areas = []
			let matches = this.allowed_areas.forEach((id) => {
				let area = this.areas.find((a) => a.value == id)
				if (area) allowed_areas.push(area)
			})
			return allowed_areas
		},

		getAllowedProfiles() {
			let allowed_profiles = []
			let matches = this.allowed_profiles.forEach((id) => {
				let profile = this.profiles.find((a) => a.value == id)
				if (profile) allowed_profiles.push(profile)
			})
			return allowed_profiles
		},

		showColumnGuestStatus() {
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj) return obj.presential_event_invited_users_show_deleted_users
			else return false
		},
	},

	methods: {
		clearAutoComplete() {
			this.branches = []
			this.companies = []
			this.requestNewGuests({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: 5,
					descending: false,
					sortBy: null,
				},
			})
		},

		fetchBranches(terms, done) {
			if (!terms.length) {
				return (this.branches = [])
			}

			this.$axios
				.get(`/admin_companies/branches/get_branches/?search=${terms}`, this.getHeader)
				.then((response) => {
					let branches = []

					branches = response.data.map((branches) => {
						return {
							id: branches.id,
							label: `${branches.name} / ${
								branches.document && branches.register
									? `${branches.document} - ${branches.register}`
									: branches.document
									? branches.document
									: branches.register
									? branches.register
									: ''
							}`,
							value: branches.id,
						}
					})
					done(branches)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectedBranch({ id }) {
			this.branches = [id]

			this.requestNewGuests({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: 5,
					descending: false,
					sortBy: null,
				},
			})
		},

		fetchCompanies(terms, done) {
			if (!terms.length) {
				return (this.companies = [])
			}

			this.$axios
				.get(`/admin_companies/companies/get_companies/?search=${terms}`, this.getHeader)
				.then((response) => {
					let companies = []

					companies = response.data.map((companies) => {
						return {
							id: companies.id,
							label: companies.name,
							value: companies.name,
						}
					})
					done(companies)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectedCompany({ id }) {
			this.companies = [id]

			this.requestNewGuests({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: 5,
					descending: false,
					sortBy: null,
				},
			})
		},

		plannedVacancies() {
			this.loading_seats = true
			this.$q.loading.show()

			this.$axios
				.get(
					`/presential_manager/presential_event_seats/${this.presential_event_id}/`,
					this.getHeader
				)
				.then((response) => {
					if (response.data.presential_seats) {
						this.presential_seats = response.data.presential_seats.map((e, index) => ({
							...e,
							tab: `t${index}`,
						}))
						this.qty_presential_event_available_seats =
							response.data.qty_presential_event_available_seats
						this.qty_presential_event_filled_seats =
							response.data.qty_presential_event_filled_seats
						this.presential_event_contain_dates =
							response.data.presential_event_contain_dates
						this.presential_event_using_presential_catalog =
							response.data.presential_event_using_presential_catalog
						this.first_event_date = response.data.first_event_date
							? moment(response.data.first_event_date).format('YYYY-MM-DD HH:mm')
							: null
						this.day_before_first_event = moment(response.data.first_event_date)
							.subtract(1, 'days')
							.format('YYYY-MM-DDTHH:mm')
						this.allow_enrollment_cancellation =
							response.data.allow_enrollment_cancellation

						this.loadGuests(this.presential_seats[0])
					}
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading_seats = false
					this.$q.loading.hide()
				})
		},

		showAddUserSeats(seat_tab) {
			this.users_not_in_seats = this.seat_tab_users
				.filter((e) => !e.is_invited_to_this_event)
				.map((e) => ({ ...e, selected: false }))
			this.selected_seat_tab = seat_tab
			this.show_add_user_seats = true
		},

		addUserNotInSeats() {
			this.$q.loading.show()

			let data = {
				guests: this.users_not_in_seats_selected.map((e) => {
					return e.user_id
				}),
			}

			this.$axios
				.post(
					`/presential_manager/presential_event_seats/${
						this.presential_event_id
					}/add_invited_user/`,
					data,
					this.getHeader
				)
				.then((response) => {
					this.$q.notify({
						message: this.$t('guests_save_success'),
						type: 'positive',
						icon: 'fal fa-save',
					})

					this.presential_seats = response.data.presential_seats.map((e, index) => ({
						...e,
						tab: `t${index}`,
					}))
					this.qty_presential_event_available_seats =
						response.data.qty_presential_event_available_seats
					this.qty_presential_event_filled_seats =
						response.data.qty_presential_event_filled_seats
					this.presential_event_contain_dates =
						response.data.presential_event_contain_dates
					this.presential_event_using_presential_catalog =
						response.data.presential_event_using_presential_catalog

					this.loadGuests(this.selected_seat_tab)
				})
				.catch((e) => {
					console.log(e)

					this.$q.notify({
						message:
							e.response && e.response.data.error
								? this.$t(e.response.data.error)
								: this.$t('guests_save_error'),
						type: 'negative',
						icon: 'fal fa-ban',
					})
				})
				.finally(() => {
					this.$q.loading.hide()
					this.show_add_user_seats = false
					this.users_not_in_seats_selected = []
				})
		},

		confirmRemoveUserInSeats(user, seat_tab) {
			this.confirm_remove_guests_observation = ''
			this.confirm_remove_user_in_seats_user = user
			this.confirm_remove_user_in_seats = true
			this.selected_seat_tab = seat_tab
		},

		removeUserInSeats() {
			this.$q.loading.show()

			let data = {
				guests: [this.confirm_remove_user_in_seats_user.row.user_id],
				observation: this.confirm_remove_guests_observation,
			}

			this.$axios
				.post(
					`/presential_manager/presential_event_seats/${
						this.presential_event_id
					}/del_invited_user/`,
					data,
					this.getHeader
				)
				.then((response) => {
					this.$q.notify({
						message: this.$t('guests_save_success'),
						type: 'positive',
						icon: 'fal fa-save',
					})

					this.presential_seats = response.data.presential_seats.map((e, index) => ({
						...e,
						tab: `t${index}`,
					}))
					this.qty_presential_event_available_seats =
						response.data.qty_presential_event_available_seats
					this.qty_presential_event_filled_seats =
						response.data.qty_presential_event_filled_seats

					this.loadGuests(this.selected_seat_tab)
				})
				.catch((e) => {
					console.log(e)

					this.$q.notify({
						message: this.$t('guests_save_error'),
						type: 'negative',
						icon: 'fal fa-ban',
					})
				})
				.finally(() => {
					this.$q.loading.hide()
					this.show_add_user_seats = false
					this.users_not_in_seats_selected = []
					this.confirm_remove_user_in_seats = false
				})
		},

		disableAddUserSeats(seat_tab) {
			if (!this.permissions.subscribe_event_users) return true
			else if (
				this.permissions.subscribe_event_users &&
				this.qty_presential_event_available_seats <=
					this.qty_presential_event_filled_seats &&
				this.seat_tab_qty_available_seats_to_this_event <=
					this.seat_tab_qty_presential_event_filled_seats
			) {
				return true
			} else {
				if (!this.subscription_restrictions) {
					if (
						this.status === 1 ||
						this.status === 2 ||
						this.status === 3 ||
						this.status === 4 ||
						this.presential_event_id == 0
					)
						return false
					else return true
				} else {
					if (this.status === 1 || this.status === 2 || this.presential_event_id == 0) {
						if (this.is_admin) {
							return false
						} else {
							let dateNow = new Date()
							let diff = date.getDateDiff(
								dateNow,
								this.day_before_first_event,
								'minutes'
							)
							if (diff >= 0) return true
							else return false
						}
					} else return true
				}
			}
		},

		checkAddUserNotInSeats() {
			if (
				this.users_not_in_seats_selected.length >
				this.selected_seat_tab.qty_available_seats_to_this_event -
					this.selected_seat_tab.qty_presential_event_filled_seats
			)
				return true
			else if (
				this.users_not_in_seats_selected.length >
				this.qty_presential_event_available_seats - this.qty_presential_event_filled_seats
			)
				return true
			else return false
		},

		selectAllNotInSeats() {
			this.users_not_in_seats_selected = this.users_not_in_seats_selected.filter(
				(e) => e.allowed_to_be_invited_to_this_event
			)
		},

		requestGuests({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let current_column = this.columns_users_invited.find(col => col.name === pagination.sortBy)
			
			let sort_field = current_column && current_column.sort ? current_column.sort : pagination.sortBy

			let order = pagination.descending ? '-' : ''
			let order_by = sort_field ? order + sort_field : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				search: this.filter_guests,
				ordering: order_by,
			}

			this.savePagination()

			this.$axios
				.get(
					`/presential/presential_events/${
						this.presential_event_id
					}/guests/?${this.$qs.stringify(data)}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count

					this.users_invited = response.data.results.map((e) => {
						return {
							...e,
							areas: e.areas ? e.areas : [],
							companies: e.branches,
							actions: e.user_id,
							status: e.status,
							selected: false,
						}
					})

					this.getVacancies()
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		requestNewGuests({ pagination }) {
			this.loading = true
			this.new_guests_pagination = pagination

			let current_column = this.guests_columns.find(col => col.name === pagination.sortBy)
			
			let sort_field = current_column && current_column.sort ? current_column.sort : pagination.sortBy

			let order = pagination.descending ? '-' : ''
			let order_by = sort_field ? order + sort_field : ''

			let data = {
				page_size: this.new_guests_pagination.rowsPerPage,
				page: this.new_guests_pagination.page,
				search: this.filter_guests,
				profiles: this.profile,
				areas: this.area,
				branches: this.branches.length ? this.branches : [],
				companies: this.companies.length ? this.companies : [],
				ordering: order_by,
			}

			this.$axios
				.get(
					`/presential/presential_events/${
						this.presential_event_id
					}/guests/get_users_not_invited/?` +
						this.$qs.stringify(data, { arrayFormat: 'repeat' }),
					this.getHeader
				)
				.then((response) => {
					this.new_guests_pagination.rowsNumber = response.data.count

					this.guests_list = response.data.results.map((e) => {
						return {
							...e,
							selected: false,
							user_id: e.id,
							profile: e.profile_name,
							branches: e.branches,
							companies: e.companies,
						}
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		changeAddFilter() {
			this.requestNewGuests({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: 5,
					descending: false,
					sortBy: null,
				},
			})
		},

		saveGuests() {
			this.$q.loading.show()

			let data = {
				users: this.users_invited
					.filter((e) => !e.invited_and_deleted)
					.map((e) => {
						return e.user_id
					}),
			}

			this.$axios
				.post(
					`/presential/presential_events/${this.presential_event_id}/guests/`,
					data,
					this.getHeader
				)
				.then((response) => {
					this.$q.notify({
						message: this.$t('guests_save_success'),
						type: 'positive',
						icon: 'fal fa-save',
					})

					this.filter_guests = ''
					this.requestGuests({
						pagination: {
							page: 1,
							rowsNumber: 10,
							rowsPerPage: 0,
							descending: false,
							sortBy: null,
						},
					})
				})
				.catch((e) => {
					console.log(e)

					this.$q.notify({
						message: this.$t('guests_save_error'),
						type: 'negative',
						icon: 'fal fa-ban',
					})
				})
				.finally(() => {
					this.$q.loading.hide()
					this.show_guests = false
					this.search = ''
				})
		},

		getVacancies() {
			this.$axios
				.get(
					`/presential/presential_events/${this.presential_event_id}/get_vacancies/`,
					this.getHeader
				)
				.then((response) => {
					this.max_participants = response.data.available_vacancies
						? response.data.available_vacancies
						: 0
					this.occupied_vacancies = response.data.occupied_vacancies
				})
				.catch((e) => {
					console.log(e)
				})
		},

		showAddGuests() {
			this.branches = []
			this.companies = []
			this.users_invited_selected = []
			this.requestNewGuests({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: 5,
					descending: false,
					sortBy: null,
				},
			})
			this.filter_guests = ''
			this.show_guests = true
		},

		addGuests() {
			if (
				this.occupied_vacancies + this.users_invited_selected.length >
				this.max_participants
			) {
				this.$q.notify({
					message: this.$t('number_of_subscribers_above_max'),
					type: 'negative',
					icon: 'fal fa-ban',
				})
				this.show_guests = false
				this.users_invited_selected = []
			} else {
				this.users_invited_selected.map((e) => {
					this.users_invited.push(e)
				})
				this.clearGuestsSelection()
				this.saveGuests()
			}
		},

		selectAllGuests() {
			// this.users_invited_selected = this.users_invited_selected.filter((e) => !e.status) Why this filter?
			this.users_invited.map((u) => ({ ...u, selected: true }))
		},

		confirmRemoveGuest(props) {
			this.confirm_remove_guests_observation = ''
			this.confirm_remove_guests_user = props
			this.confirm_remove_guest = true
		},

		removeGuest() {
			let data = {
				users: [this.confirm_remove_guests_user.row.user_id],
				observation: this.confirm_remove_guests_observation,
			}

			this.$axios
				.post(
					`/presential/presential_events/${
						this.presential_event_id
					}/guests/delete_invited_users/`,
					data,
					this.getHeader
				)
				.then(() => {
					this.requestGuests({
						pagination: {
							page: 1,
							rowsNumber: 10,
							rowsPerPage: 0,
							descending: false,
							sortBy: null,
						},
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.confirm_remove_guest = false
				})
		},

		confirmRemoveGuests() {
			this.confirm_remove_guests_observation = ''
			this.confirm_remove_guests = true
		},

		removeGuests() {
			if (this.users_invited_selected.length) {
				let data = {
					users: this.users_invited_selected.map((e) => e.user_id),
					observation: this.confirm_remove_guests_observation,
				}

				this.$axios
					.post(
						`/presential/presential_events/${
							this.presential_event_id
						}/guests/delete_invited_users/`,
						data,
						this.getHeader
					)
					.then(() => {
						this.requestGuests({
							pagination: {
								page: 1,
								rowsNumber: 10,
								rowsPerPage: 0,
								descending: false,
								sortBy: null,
							},
						})
					})
					.catch((e) => {
						console.log(e)
					})
					.finally(() => {
						this.confirm_remove_guests = false
						this.users_invited_selected = []
					})
			}
		},

		clearGuestsSelection() {
			this.users_invited_selected = []
			this.requestGuests({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: 5,
					descending: false,
					sortBy: null,
				},
			})
		},

		showCreateUsersGuests() {
			this.show_create_users = true
		},

		addNewUser() {
			this.$v.new_user.$touch()

			if (!this.$v.new_user.$error) {
				let user = {
					document: this.new_user.document,
					profile: this.new_user.profile,
					full_name: this.new_user.full_name,
				}

				if (!this.register_fields.email_fields && this.new_user.email === '') {
					let url = process.env.SITE_URL.replace(
						/^(?:https?:\/\/)?(?:www\.)?/i,
						''
					).split('/')[0]

					user.email = `${this.new_user.document}@${url}`
				} else {
					user.email = this.new_user.email
				}

				this.new_users.push(user)

				this.new_user = {
					email: '',
					email_error: false,
					document: '',
					document_error: false,
					profile: '',
					full_name: '',
				}

				this.$v.$reset()
			}
		},

		removeNewUser(index) {
			this.new_users.splice(index, 1)
		},

		saveNewUsers() {
			this.$q.loading.show()

			if (!this.register_fields.email_fields && this.register_store.default_password) {
				this.new_users = this.new_users.map((e) => {
					return { ...e, password_to_change: this.register_store.default_password }
				})
			}

			let data = {
				new_users: this.new_users,
				presential_event: this.presential_event_id,
			}

			this.$axios
				.post(
					`/presential/presential_events/save_new_users_presential/`,
					data,
					this.getHeader
				)
				.then((response) => {
					response.data.map((e) => {
						this.users_invited.push(e)
					})

					this.saveGuests()
					this.hideCreateUsers()
				})
				.catch((e) => {
					console.log(e)

					this.$q.notify({
						message: this.$t('new_users_save_error'),
						type: 'negative',
						icon: 'fal fa-ban',
					})

					this.$q.loading.hide()
				})
		},

		hideCreateUsers() {
			this.show_create_users = false
			this.new_user = {
				email: '',
				email_error: false,
				document: '',
				document_error: false,
				profile: '',
				full_name: '',
			}
			this.new_users = []
		},

		getQuantityBranches(branches) {
			return branches.length > 0 ? branches.length : '0'
		},

		getQuantityCompanies(companies) {
			return companies.length > 0 ? companies.length : '0'
		},

		emailUnique() {
			if (this.new_user.email) {
				let fd = new FormData()
				fd.append('email', this.new_user.email)

				this.$axios
					.post(`/register_user/check_user_email_existance/`, fd, this.getHeader)
					.then((response) => {
						if (response.data.exists) {
							this.new_user.email_error = true
						} else this.new_user.email_error = false
					})
					.catch((e) => {
						console.log(e)
					})
			} else this.new_user.email_error = false
		},

		documentUnique() {
			if (this.new_user.document) {
				let fd = new FormData()
				fd.append('document', this.new_user.document)

				this.$axios
					.post(`/register_user/check_user_document_existance/`, fd, this.getHeader)
					.then((response) => {
						if (response.data.exists) {
							this.new_user.document_error = true
						} else this.new_user.document_error = false
					})
					.catch((e) => {
						console.log(e)
					})
			} else this.new_user.document_error = false
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		showImportGuests() {
			this.show_guests_import = true
		},

		userImportUpload(url) {
			this.file = url
		},

		importUser() {
			if (this.file) {
				let data = {
					file_url: this.file,
				}
				this.$axios
					.post(
						`admin_import/presential/${this.presential_event_id}/subscribers/save/`,
						data,
						this.getHeader
					)
					.then(() => {
						this.$q.notify({
							message: this.$t('guests_save_success'),
							type: 'positive',
							icon: 'fal fa-save',
						})
					})
					.catch((e) => {
						if (e && e.response && e.response.data) {
							if (e.response.data.message.includes('Há mais usuários')) {
								this.$q.notify({
									message: this.$t(
										'there_are_more_users_than_allowed_for_this_event'
									),
									type: 'negative',
									icon: 'fal fa-ban',
								})
							}
						} else {
							this.$q.notify({
								message: this.$t('guests_save_error'),
								type: 'negative',
								icon: 'fal fa-ban',
							})
						}
					})
					.finally(() => {
						let pagination = {
							page: 1,
							rowsPerPage: 0,
							descending: false,
							sortBy: null,
						}

						this.requestGuests({ pagination })
						this.$q.loading.hide()
						this.show_guests_import = false
					})
			} else {
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		getTemplate() {
			this.$q.loading.show({
				message: 'Aguarde, gerando planilha',
			})
		
			this.$axios
				.get(
					`admin_import/presential/${this.presential_event_id}/subscribers/load_template/`,
					this.getHeader
				)
				.then((response) => {
					this.forceFileDownload(response.data.template_download_url)
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		downloadGuestList() {
			let message = this.$t('generating_guest_list_download_message')
			this.$q.loading.show({
				message,
			})
			this.$axios
				.get(
					`/presential/presential_events/${
						this.presential_event_id
					}/guests/generate_report/`,
					this.getHeader
				)
				.then((response) => {
					this.forceFileDownload(response.data.path_url)
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		forceFileDownload(response) {
			const link = document.createElement('a')
			link.href = response
			link.target = '_blank';
			link.rel = 'noopener noreferrer';
			document.body.appendChild(link)
			link.click()
		},

		chevroletDocumentFix() {
			if (
				process.env.PROJECT_FOLDER === 'universidadechevrolet' &&
				this.id_user_client_country_selected === 32 &&
				this.id_user_language_selected == 1
			) {
				this.columns_users_invited = this.columns_users_invited.map((e) =>
					e.field == 'document' ? { ...e, label: 'cpf' } : e
				)
				this.guests_columns = this.guests_columns.map((e) =>
					e.field == 'document' ? { ...e, label: 'cpf' } : e
				)
			} else {
				this.columns_users_invited = this.columns_users_invited.map((e) =>
					e.field == 'document' ? { ...e, label: 'document' } : e
				)
				this.guests_columns = this.guests_columns.map((e) =>
					e.field == 'document' ? { ...e, label: 'document' } : e
				)
			}
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm:ss'
						break
					default:
						format = 'MM-DD-YYYY HH:mm:ss'
						break
				}

				return date.formatDate(d, format)
			}
		},

		getArea(area) {
			if (this.areas_client) {
				let obj = this.areas_client.find((obj) => {
					return obj.value === area
				})
				if (obj) return obj.label
			}
			return ''
		},

		loadGuests(seat_tab) {
			if (seat_tab) {
				let presential_seat_id = ''
				if (typeof seat_tab === 'string') {
					presential_seat_id = this.presential_seats.find((e) => e.tab === seat_tab)
						.presential_seat_id
				} else {
					presential_seat_id = seat_tab.presential_seat_id
				}

				this.loading_seat_tab_users = true
				this.seat_tab_users = []
				this.seat_tab_qty_available_seats_to_this_event = 0
				this.seat_tab_qty_presential_event_filled_seats = 0

				this.$axios
					.get(
						`/presential_manager/presential_event_seats/${
							this.presential_event_id
						}/presential_event_seat/${presential_seat_id}/`,
						this.getHeader
					)
					.then((response) => {
						this.seat_tab_users = response.data.users
						this.seat_tab_qty_available_seats_to_this_event =
							response.data.qty_available_seats_to_this_event
						this.seat_tab_qty_presential_event_filled_seats =
							response.data.qty_presential_event_filled_seats
					})
					.catch((e) => {
						console.log(e)
					})
					.finally(() => {
						this.loading_seat_tab_users = false
					})
			}
		},

		translateProfiles(profileLabel) {
			const profile = profileLabel.toUpperCase()
			const term = this.profiles.find((e) =>
				e.translations.find((translation) => translation.name.toUpperCase() === profile)
			)
			if (term) {
				const term_translation = term.translations.find(
					(lang) => lang.language_id === this.id_user_language_selected
				)
				if (term_translation) {
					let translatedProfile = term_translation.name.toLowerCase()
					return translatedProfile.charAt(0).toUpperCase() + translatedProfile.slice(1)
				} else return profileLabel
			} else return profileLabel
		},

		checkUserIsAdmin() {
			let obj = this.user_clients.find((obj) => obj.id === this.id_user_client_selected)
			if (obj) {
				let userProfile = obj.client_profiles.find((profile) => profile.is_user_profile)
				if (userProfile) this.is_admin = userProfile.is_admin
			} else this.is_admin = false
		},

		checkSubscriptionConfiguration() {
			let client = this.clients.find((obj) => obj.id === this.id_user_client_selected)
			if (client)
				this.subscription_restrictions = !client.allow_presential_event_invite_after_start
			else this.subscription_restrictions = false
		},

		hideSubscriptionHistory() {
			this.show_subscription_history = false
			this.user_to_cancel_subscription = null
		},

		getPlannedVacanciesGuestStatus(guest) {
			if (guest) {
				const user = this.seat_tab_users.find((e) => e.user_id === guest.user_id)
				if (user) {
					switch (user.status) {
						case 1:
							return 'invited'
						case 2:
							return 'deleted'
						case 4:
							return 'awaiting_cancellation'
						case 5:
							return 'enrollment_canceled'
						default:
							return 'invited'
					}
				}
			} else return 'invited'
		},

		cancelUserSubscription(row, seat_tab) {
			const user = this.seat_tab_users.find((e) => e.user_id === row.user_id)
			this.selected_seat_tab = seat_tab

			this.user_to_cancel_subscription = user
			this.show_subscription_history = true
		},

		saveCancellationAndLoadGuests() {
			this.requestGuests({ pagination: this.server_pagination })
			this.hideSubscriptionHistory()
		},

		savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
		},

		loadPagination() {
			this.server_pagination.rowsPerPage = this.num_rows
		},

		closeGuestModal() {
			this.show_guests = false
			this.filter_guests = ''
			this.requestGuests({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: 0,
					descending: false,
					sortBy: null,
				},
			})
		},
	},

	created() {
		this.presential_event_id = this.$route.params.id
		this.loadPagination()
		this.plannedVacancies()

		this.requestGuests({
			pagination: this.server_pagination,
		})
		this.checkUserIsAdmin()
		this.checkSubscriptionConfiguration()
		this.chevroletDocumentFix()
	},

	watch: {
		id_user_language_selected: function() {
			this.chevroletDocumentFix()
		},
	},

	validations() {
		return {
			new_user: {
				email: {
					email,
					requiredIf: requiredIf(() => {
						return (
							this.register_fields.email_fields &&
							this.register_fields.email_fields_mandatory
						)
					}),
					emailUnique() {
						if (!this.new_user.email_error) return true
						else return false
					},
				},
				document: {
					requiredIf: requiredIf(() => {
						return (
							this.register_fields.document && this.register_fields.document_mandatory
						)
					}),
					documentUnique() {
						if (!this.new_user.document_error) return true
						else return false
					},
				},
				profile: { required },
				full_name: { required },
			},
		}
	},
}
</script>

<style></style>
